module.exports = __webpack_public_path__ + "static/media/pay_card_kz.7c244910.png";